(function () {
  function withAutoplayYouTube(src) {
    if (!src) return src;
    // If already has autoplay, keep it.
    if (src.indexOf("autoplay=1") !== -1) return src;

    const hasQuery = src.indexOf("?") !== -1;
    const sep = hasQuery ? "&" : "?";
    // Add autoplay=1 (user click = gesture, should play)
    return src + sep + "autoplay=1";
  }

  function initPlaylist(root) {
    const player = root.querySelector("[data-vpl-player]");
    const items = Array.from(root.querySelectorAll("[data-vpl-item]"));
    if (!player || items.length === 0) return;

    const sourcesByIndex = new Map();
    root.querySelectorAll("[data-vpl-source]").forEach((holder) => {
      const parent = holder.closest("[data-vpl-item]");
      if (!parent) return;
      const idx = Number(parent.getAttribute("data-index"));
      sourcesByIndex.set(idx, holder);
    });

    function setActive(index) {
      // Update active states (desktop + mobile)
      items.forEach((btn) => {
        const isOn = Number(btn.getAttribute("data-index")) === index;
        btn.classList.toggle("is-active", isOn);
        btn.setAttribute("aria-pressed", isOn ? "true" : "false");
      });

      const source = sourcesByIndex.get(index);
      if (!source) return;

      // Replace player content
      const clone = source.cloneNode(true);
      clone.removeAttribute("hidden");

      player.innerHTML = "";
      Array.from(clone.childNodes).forEach((n) => player.appendChild(n));

      // AUTOPLAY after switch
      const video = player.querySelector("video");
      if (video) {
        // Ensure it can play on click
        try {
          const p = video.play();
          if (p && typeof p.catch === "function") p.catch(() => {});
        } catch (e) {}
      }

      const iframe = player.querySelector('iframe[data-youtube="true"], iframe');
      if (iframe) {
        const src = iframe.getAttribute("src") || "";
        iframe.setAttribute("src", withAutoplayYouTube(src));
      }

      // On mobile, keep active thumb in view (optional)
      const activeMobile = root.querySelector(".vpl__mobile-strip .vpl__mthumb.is-active");
      if (activeMobile && activeMobile.scrollIntoView) {
        activeMobile.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
      }
    }

    // Bind clicks
    items.forEach((btn) => {
      btn.addEventListener("click", () => {
        const idx = Number(btn.getAttribute("data-index"));
        if (Number.isFinite(idx)) setActive(idx);
      });
    });
  }

  function initAll() {
    document.querySelectorAll("[data-video-playlist]").forEach(initPlaylist);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();